import React from 'react';
import { ItemCard } from '../ItemCard';
import {
  displayEligibilityMessage,
  getItemEligibilityMsg,
} from '../../services/return-items-service/utils';

export const ItemList = ({
  items,
  onClick,
  orderNumber,
  selected = [],
  disabled = [],
  readOnly,
  borderless,
  showCheckmark,
  ineligible = false,
  itemQtyKey,
}) =>
  items.map((orderItem, itemIndex) => {
    const item = [].find((e) => e.item_id === orderItem.item_id) || orderItem;
    return (
      <ItemCard
        key={item.item_id}
        item={item}
        imageSize="large"
        showCheckmark={showCheckmark}
        active
        onClick={(props) => {
          onClick({ ...props, orderNumber });
        }}
        disabled={disabled.includes(item.item_id)}
        selected={selected.includes(item.item_id)}
        itemIndex={itemIndex}
        readOnly={readOnly}
        borderless={borderless}
        eligibleStatus={ineligible ? getItemEligibilityMsg(item) : displayEligibilityMessage(item)}
        itemQtyKey={itemQtyKey}
      />
    );
  });
